import { render, staticRenderFns } from "./ItemWrapper.vue?vue&type=template&id=11e8ec16&"
import script from "./ItemWrapper.vue?vue&type=script&lang=js&"
export * from "./ItemWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports